"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M2.488 5.081h12c.22 1.181 1.22 2.054 2.39 2.054 1.17 0 2.17-.873 2.39-2.054h2.244A.503.503 0 0 0 22 4.568a.503.503 0 0 0-.488-.514h-2.244C19.048 2.873 18.048 2 16.878 2c-1.17 0-2.17.873-2.39 2.054h-12A.503.503 0 0 0 2 4.568c0 .282.22.513.488.513zm14.39-2.054c.805 0 1.463.693 1.463 1.54 0 .848-.658 1.541-1.463 1.541s-1.463-.693-1.463-1.54c0-.848.658-1.541 1.463-1.541zm4.634 7.96h-12c-.22-1.182-1.22-2.055-2.39-2.055-1.17 0-2.17.873-2.39 2.054H2.488A.503.503 0 0 0 2 11.5c0 .282.22.514.488.514h2.244c.22 1.18 1.22 2.054 2.39 2.054 1.17 0 2.17-.873 2.39-2.054h12A.503.503 0 0 0 22 11.5a.503.503 0 0 0-.488-.514zM7.122 13.04c-.805 0-1.463-.694-1.463-1.541s.658-1.54 1.463-1.54 1.463.693 1.463 1.54c0 .847-.658 1.54-1.463 1.54zm14.39 4.878H14.39c-.22-1.181-1.22-2.054-2.39-2.054-1.17 0-2.17.873-2.39 2.054H2.488a.503.503 0 0 0-.488.513c0 .283.22.514.488.514H9.61C9.83 20.127 10.83 21 12 21c1.17 0 2.17-.873 2.39-2.054h7.122a.503.503 0 0 0 .488-.514.503.503 0 0 0-.488-.513zM12 19.973c-.805 0-1.463-.693-1.463-1.54 0-.848.658-1.541 1.463-1.541s1.463.693 1.463 1.54c0 .848-.658 1.541-1.463 1.541z"
}), 'Filter');

exports.default = _default;